/* eslint-disable consistent-return */

import Component from '@bythepixel/component-loader';
import Config from './config';

export default class FavoriteCounter extends Component {
  static selector = Config.selector;

  constructor(containerEl, options) {
    super(containerEl, options);

    this.initCounter();
  }

  getCounter() {
    return document.querySelector(FavoriteCounter.selector);
  }

  initCounter() {
    const counter = this.getCounter();

    if (!counter) return;

    const count = counter.querySelector('.favorites__count').textContent.trim();

    this.updateCounterValue(count);
    this.updateAriaHidden();
  }

  updateCounterValue(count) {
    const counter = this.getCounter();

    if (!counter) return;

    counter.querySelector('.favorites__count').textContent = count;
    this.count = count;
  }

  updateAriaHidden() {
    this.$container.ariaHidden = this.count === 0;
  }

  get count() {
    const counter = this.getCounter();

    if (!counter) return;

    return parseInt(counter.dataset.numberOfFavorites);
  }

  set count(newCount) {
    const counter = this.getCounter();

    if (!counter) return;

    counter.dataset.numberOfFavorites = newCount;
  }
}
